module.exports = __webpack_public_path__ + "static/media/wave.7e7b78de.svg";